import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import moment from 'moment';
import { boardsActions } from '../../../store/boards';

// https://github.com/ashvin27/react-datatable
import ReactDatatable from '@ashvin27/react-datatable';

class Sniffleader extends React.Component {

    constructor(props) {
        super(props);

        this.config = {
            page_size: 10,
            length_menu: [10, 20, 50],
            no_data_text: '데이터가 없습니다!',
            language: {
                length_menu: "보기_MENU_ 페이지 당 줄수",
                filter: "검색...",
                info: "_START_ ~ _END_ / 전체: _TOTAL_ ",
                pagination: {
                    first: "처음",
                    previous: "이전",
                    next: "다음",
                    last: "마지막"
                }
            },
            show_length_menu: false,
            show_filter: true,
            show_pagination: true,
            show_info: true,
            //sort: { column: "time", order: "desc" },            
            sort: {}
        }
        this.columns = [
            {
                key: "id",
                text: "번호",
                className: "text-center",
                align: "center",
                sortable: false,
                width: 60,
                cell: record => {
                    if (record.fixed) return "공지";
                    else return record.id;
                }
            },
            {
                key: "title",
                text: "제목",
                className: "",
                align: "center",
                sortable: false,
                cell: record => {
                    const file = record.files.map((item, index) => {
                        if (item.type === 'attachments') return item;
                        return null
                    })
                    return (
                        <Link to={{ pathname: `/details/report/resource/${record.boardId}` }} className="g-color-black">
                            {record.title} {/*file ? <i className="fa fa-file g-pl-10 g-color-gray-light-v2"></i> : "" */}
                        </Link>
                    );
                }
            },
            {
                key: "hit",
                text: "조회수",
                className: "text-center g-hidden-sm-down",
                align: "center",
                sortable: false
            },
            {
                key: "time",
                text: "등록일자",
                className: "text-center g-hidden-sm-down",
                sortable: false,
                align: "center",
                cell: record => {
                    return (<span> {moment(record.time).format("YYYY-MM-DD")} </span>);
                }
            }
        ];
    }

    componentDidMount() {
        document.querySelector("main").scrollIntoView();
        this.props.getDictionary(this.props.location.pathname.split('/')[1], this.props.location.pathname.split('/')[2]);
    }

    render() {
        if (!this.props.boards.boards && this.props.boards.length === 0) return null;
        //console.log(this.props.boards);

        let endOfFixed = false;
        let boards = this.props.boards.boards;
        let key = boards.length;
        for (let i = 0; i < boards.length; i++) {
            boards[i].id = key--;                                     // id key  추가
            if (!boards[i].fixed) endOfFixed = true;
            if (endOfFixed) boards[i].fixed = false;              // trick for 공지/번호
        }

        return (
            <div className="container g-pt-0 g-pb-60">

                <ul className="nav nav-justified u-nav-v2-1 u-nav-primary g-my-20">
                    <li className="nav-item"><Link to="/report/newsletter" className="nav-link g-brd-gray-light-v4 g-font-size-16">카라에듀</Link></li>
                    <li className="nav-item"><Link to="#!" className="nav-link g-brd-gray-light-v4 g-font-size-16 active">킁킁리더</Link></li>
                </ul>

                <ReactDatatable className="table table-hover g-brd-y g-brd-gray-light-v3-top"
                    config={this.config}
                    records={boards}
                    columns={this.columns}
                />
            </div>
        )
    }
}

export default connect(
    state => state.boards,
    dispatch => bindActionCreators({ ...boardsActions }, dispatch)
)(withRouter(Sniffleader));


// WEBPACK FOOTER //
// ./src/pages/front/report/sniffleader.js